import { connect } from 'react-redux';
import { actions as composerPopoverActions } from '~/composer-popover';
import { SEGMENT_NAMES } from '~/constants';
import { contentCreate } from '~/routes';
import { WelcomeChecklist } from './components/WelcomeChecklist';

// Experiment 75 is in progress and implies to show Create as a new menu item at top menu, so
// if segment B in experiment 75 is enabled, we should go to ideas using window.location instead of routes

export default connect(null, (dispatch) => ({
  onCreateIdeaClick: (isEID75SegmentBEnabled) => {
    if (isEID75SegmentBEnabled) {
      window.location.assign('/content');
    } else {
      dispatch(contentCreate.goTo());
    }
  },
  onPublishFirstPostClick: ({ selectedProfileId, selectedProfileIds }) => {
    dispatch(
      composerPopoverActions.handleCreatePostClick({
        selectedProfileId,
        selectedProfileIds,
        cta: SEGMENT_NAMES.CALENDAR_CREATE_A_POST,
      })
    );
  },
}))(WelcomeChecklist);
